import { urls } from "app/constants";
import { useApiAlter } from "./index";
// import { dtoFormikServerErr, dtoProfile } from "app/utils/dto";

export const useApiArticles = () =>
  useApiAlter({ url: urls.articles, method: "get" });
